import queryString from 'query-string';
import type { NskResponse } from '~/models/Api';
import type { ConstructionItemSettingEdit } from '~/models/ConstructionItemSetting';
import { postRequest } from '../api_handler';

const paths = {
  create: '/vendors/construction_item_settings/'
};

export const create = async (
  constructionItemSettings: ConstructionItemSettingEdit[],
  companyMasterId: number
): Promise<NskResponse<void>> =>
  postRequest(
    queryString.stringifyUrl({
      url: paths.create,
      query: { company_master_id: companyMasterId }
    }),
    {
      constructionItemSettings
    }
  );
